'use strict';

export class EnterYearDialogModel {
    year = null;
    from = 0;
    to = 0;
    range = 100;
    constructor(options) {
        this.from = options.to - this.range;
        this.to = options.to;
    }

    getYear(){
        if (this.year === null || this.year < this.from || this.year > this.to){
            return;
        }
        return this.year;
    }
}



// WEBPACK FOOTER //
// ./src/scripts/models/enterYearDialogModel.js